var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-img',{attrs:{"aspect-ratio":9/19,"contain":"","src":require("@/assets/img/checkmong/azq/scene5-6.gif")}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }